import React, { useState, useEffect } from "react";
import SuggestionModal from "./SuggestionModal";

const LANGUAGE_SUGGESTIONS = [
    "English",
    "Hindi",
    "Malayalam",
    "Tamil",
    "Telugu",
    "Kannada",
    "Arabic",
    "Urdu",
    "French",
    "German",
    "Spanish",
    "Italian"
];

export default function LanguageForm({ onSave, onCancel, initialData }) {

    const [form, setForm] = useState(
        initialData || {
            language: "",
            proficiency: "",
        }
    );

    const [showSuggestions, setShowSuggestions] = useState(false);

    useEffect(() => {
        if (initialData) {
            setForm(initialData);
        }
    }, [initialData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSave = () => {
        onSave(form);
    };

    return (
        <div className="form-container">

            {/* LANGUAGE INPUT */}
            <div className="form-group">
                <label>Language</label>

                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <input
                        name="language"
                        value={form.language}
                        onChange={handleChange}
                        placeholder="e.g., English, Hindi, Arabic"
                        style={{ flex: 1 }}
                    />

                    <button
                        type="button"
                        className="suggest-btn"
                        onClick={() => setShowSuggestions(true)}
                    >
                        💡 Suggestions
                    </button>
                </div>
            </div>

            {/* PROFICIENCY */}
            <div className="form-group">
                <label>Proficiency</label>
                <select
                    name="proficiency"
                    value={form.proficiency}
                    onChange={handleChange}
                >
                    <option value="">Select proficiency...</option>
                    <option value="Beginner">Beginner</option>
                    <option value="Intermediate">Intermediate</option>
                    <option value="Fluent">Fluent</option>
                    <option value="Native">Native</option>
                </select>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
                <button className="cancel-btn" onClick={onCancel}>Cancel</button>
                <button className="save-btn" onClick={handleSave}>Save</button>
            </div>

            {/* ✅ SUGGESTION MODAL */}
            {showSuggestions && (
                <SuggestionModal
                    suggestions={LANGUAGE_SUGGESTIONS}
                    onInsert={(selectedLanguages) => {
                        setForm({
                            ...form,
                            language: selectedLanguages.join(", ")
                        });
                        setShowSuggestions(false);
                    }}
                    onClose={() => setShowSuggestions(false)}
                />
            )}
        </div>
    );
}